import { render } from "./message-bubble.vue?vue&type=template&id=6d6542c8&scoped=true&ts=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts"
export * from "./message-bubble.vue?vue&type=script&lang=ts"

import "./message-bubble.vue?vue&type=style&index=0&id=6d6542c8&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6542c8"]])

export default __exports__